import React from 'react'
import {withRouter} from 'react-router-dom'
import Loader from 'react-loader-spinner'
import {logOut} from "../../../dataHelpers/authenticationHelpers"
import {pageHelpers} from '../'

class LogOutPage extends React.Component {
    constructor(props) {
        super(props)
        const {onComplete, refreshTokenTimer} = props
        pageHelpers.setupPropsForPage(props, this)

        this.onComplete = onComplete
        this.refreshTokenTimer = refreshTokenTimer
    }

    componentWillReceiveProps(nextProps) {
        const {onComplete, refreshTokenTimer} = nextProps
        pageHelpers.setupPropsForPage(nextProps, this)

        this.onComplete = onComplete
        this.refreshTokenTimer = refreshTokenTimer
    }

    async componentDidMount() {
        logOut(this.token, this.refreshTokenTimer, this.history)
        await this.onComplete()
    }

    render() {
        return <Loader type="TailSpin" color="orange" width={60} height={60}/>
    }
}

export default withRouter(LogOutPage)



// WEBPACK FOOTER //
// ./src/components/pages/authentication/LogOutPage.js